export enum Period {
    SIX_MONTHS = '6M',
    ONE_YEARS = '1Y',
    THREE_YEARS = '3Y',
    YEAR_TO_DATE = 'YTD',
    MAX = 'MAX'
}
